import { render } from "./IFS.vue?vue&type=template&id=6580d27f&scoped=true"
import script from "./IFS.vue?vue&type=script&lang=js"
export * from "./IFS.vue?vue&type=script&lang=js"

import "./IFS.vue?vue&type=style&index=0&id=6580d27f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6580d27f"

export default script